/** Necesidades especiales del cliente (coinciden con la API). */
export const NEEDS: Array<{ id: string; label: string; emoji: string }> = [
  { id: 'WHEELCHAIR', label: 'Silla de ruedas', emoji: '♿' },
  { id: 'PET', label: 'Viajo con mascota', emoji: '🐾' },
  { id: 'CHILD_SEAT', label: 'Asiento para niño', emoji: '🧒' },
  { id: 'HEARING', label: 'Problemas de audición', emoji: '🦻' },
  { id: 'VISION', label: 'Problemas de visión', emoji: '🦯' },
  { id: 'LUGGAGE_HELP', label: 'Ayuda con el equipaje', emoji: '🧳' },
];

export const needLabel = (id: string) => NEEDS.find((n) => n.id === id) ?? { id, label: id, emoji: '•' };

/** Enlace para ver el estado de un vuelo (FlightAware, gratis). */
export const flightLink = (flight: string) => `https://www.flightaware.com/live/flight/${encodeURIComponent(flight)}`;
